import * as angular from 'angular';
import * as _ from 'lodash';

import { applicationsFavorites, Roles, whiteBackgroundColor } from '../../../common';
import { ComponentDefinition } from '../../../models';
import { IConfigurationService, IUserSettingsService } from '../../../services';
import { ApplicationViewModel } from '../applicationViewModel';

interface AppTileBackground {
    url?: string;
    color?: string;
    title?: string;
}

class ApplicationTileController implements angular.IComponentController {
    application: ApplicationViewModel;
    background: AppTileBackground;
    isFavourite: boolean;
    isIdle: boolean;
    hasIdleRole: boolean;
    onDelete: (value: { applicationGuid: string }) => void;
    onIdleClick: (value: { tuple: ApplicationViewModel; $event: angular.IAngularEvent }) => void;
    onImageClick: (value: { tuple: ApplicationViewModel; $event: angular.IAngularEvent }) => void;

    static $inject = [
        '$translate',
        'configurationService',
        'userSettingsService',
    ];

    constructor(
        private _$translate: angular.translate.ITranslateService,
        private _configurationService: IConfigurationService,
        private _userSettingsService: IUserSettingsService,
    ) {
    }

    $onInit() {
        this.computeIdleRight();
    }

    $onChanges(changesObj: angular.IOnChangesObject) {
        if (changesObj['application']?.currentValue) {
            const tuple: ApplicationViewModel = changesObj['application'].currentValue;

            this.isFavourite = tuple.isFavourite;
            this.isIdle = tuple.item1.isIdleMode;
            let title = this._$translate.instant('Connect to application');
            if (this.isIdle) {
                title = `${this._$translate.instant('Application is in idle mode.')}\n${title}`;
            }

            const background = {
                title,
                url: this.background?.url,
                color: this.background?.color
            };

            let url = tuple.item1.backgroundUrl;
            if (url) {
                if (url.indexOf('http') !== 0) {
                    const appUrl = encodeURIComponent(tuple.item1.guid);
                    // API url HAS to end with a /. Nothing works otherwise.
                    url = `${this._configurationService.configuration.apiUrl}content/${appUrl}/${url}`;
                }
                background.url = url;
                background.color = whiteBackgroundColor;
            }

            this.background = background;
            this.computeIdleRight();
        }
    }

    onFavouriteClick($event: angular.IAngularEvent) {
        $event.stopPropagation();
        this.isFavourite = !this.isFavourite;
        const appGuid = this.application.item1.guid;
        let settings = this._userSettingsService.getTypedSettingValue<string[]>(applicationsFavorites);
        if (!settings) {
            settings = [];
        }
        if (this.isFavourite) {
            settings.push(appGuid);
        } else {
            settings = settings.filter(s => s !== appGuid);
        }
        this._userSettingsService.setTypedSettingValue<string[]>(applicationsFavorites, settings);
    }

    onBackgroundClick($event: angular.IAngularEvent) {
        if (this.onImageClick) {
            this.onImageClick({ tuple: this.application, $event });
        }
    }

    onIdleModeClick($event: angular.IAngularEvent) {
        if (this.onIdleClick) {
            this.onIdleClick({ tuple: this.application, $event });
        }
    }

    private computeIdleRight() {
        let result = false;
        if (this.application.currentUserRoles?.length > 0) {
            result = _.some(this.application.currentUserRoles, r => Roles.idleRoles.indexOf(r) >= 0);
        }
        this.hasIdleRole = result;
    }
}

export const wtApplicationTile: ComponentDefinition = {
    componentId: 'wtApplicationTile',
    controller: ApplicationTileController,
    template: require('./applicationTile.component.html'),
    controllerAs: 'vm',
    bindings: {
        application: '<',
        isSelected: '<',
        canDelete: '<',
        onDelete: '&?',
        onImageClick: '&?',
        onIdleClick: '&?'
    }
};